import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { filter, map, startWith } from 'rxjs';

import { APP_ROUTES } from '@core/constants/routes.constants';
import { CodeConfirmationHostComponent } from '@shared/ui/molecules/code-confirmation-host/code-confirmation-host.component';
import { ToastModule } from 'primeng/toast';

interface ShellNavLink {
  label: string;
  route: string;
}

interface ShellHeader {
  title: string;
  navLabel: string;
  links: ShellNavLink[];
}

const RESERVATIONS_HEADER: ShellHeader = {
  title: 'Smartlinks Reservations Admin',
  navLabel: 'Reservas',
  links: [
    { label: 'Reservas', route: APP_ROUTES.RESERVATIONS.LIST },
    { label: 'Gestión con el proveedor', route: APP_ROUTES.FULFILLMENT.QUEUE },
    { label: 'Pagos a proveedores', route: APP_ROUTES.SUPPLIER_PAYABLES.LIST }
  ]
};
const SETTINGS_HEADER: ShellHeader = { title: 'Smartlinks Settings', navLabel: 'Configuraciones', links: [] };

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, MatButtonModule, CodeConfirmationHostComponent, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'smartlinks-reservations-admin';

  private readonly router = inject(Router);

  // Settings (agencies) is a separate back-office from reservations, not a section of it —
  // the shell must brand itself accordingly. Routes outside both (auth, unauthorized, 404)
  // get no header at all rather than defaulting to either admin's branding.
  protected readonly header$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map((event) => event.urlAfterRedirects),
    startWith(this.router.url),
    map((url): ShellHeader | null => {
      if (url.startsWith(APP_ROUTES.SETTINGS.BASE)) return SETTINGS_HEADER;
      if (url.startsWith(APP_ROUTES.RESERVATIONS.BASE)) return RESERVATIONS_HEADER;
      return null;
    })
  );
}
